import { PlaybookLang } from './types';

/** UI labels of the guide itself. The guide content comes from the markdown files, not from here. */
const STRINGS = {
  fab: { vi: 'Hướng dẫn sử dụng', en: 'How to use this screen' },
  title: { vi: 'Hướng dẫn sử dụng', en: 'User guide' },
  search: { vi: 'Tìm trong hướng dẫn…', en: 'Search the guide…' },
  results: { vi: 'kết quả', en: 'results' },
  noResults: { vi: 'Không tìm thấy kết quả phù hợp.', en: 'No matching results.' },
  expand: { vi: 'Mở rộng toàn màn hình', en: 'Expand to full screen' },
  collapse: { vi: 'Thu nhỏ', en: 'Collapse' },
  close: { vi: 'Đóng', en: 'Close' },
  copyLink: { vi: 'Sao chép liên kết mục này', en: 'Copy link to this section' },
  linkCopied: { vi: 'Đã sao chép liên kết', en: 'Link copied' },
  linkCopyFailed: { vi: 'Không sao chép được liên kết', en: 'Could not copy the link' },
  navLabel: { vi: 'Mục lục', en: 'Table of contents' },
  pickSection: { vi: 'Chọn mục', en: 'Pick a section' },
  loadFailed: { vi: 'Không tải được hướng dẫn', en: 'Could not load the guide' },
  invalidFiles: {
    vi: 'Hai bản VI và EN không khớp nhau, hướng dẫn chưa được nạp:',
    en: 'The VI and EN files do not match, so the guide was not loaded:',
  },
} as const;

export type PlaybookStringKey = keyof typeof STRINGS;

export const tr = (key: PlaybookStringKey, lang: PlaybookLang): string => STRINGS[key][lang];
